import React from 'react'
import PreCards from './PreCards'

const Premium = () => {
  return (
  
      <PreCards />    
 
  )
}

export default Premium
